'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const TableVaultError = () => {
  return <ErrorDataUnavailable minHeight="769px" style={{ backgroundColor: 'transparent' }} />
}

export default memo(TableVaultError)
